import React, { useState, useEffect, Suspense } from 'react';
import clsx from 'clsx';
import { Paper, makeStyles, TableBody, TableRow, TableCell, Button, IconButton, Tooltip, CircularProgress } from '@material-ui/core';
import useTable from '../useTable';
import SearchIcon from '@material-ui/icons/Search';
import { dateFormatter } from '../Models/CommonFunc'
import CheckUserProvider from '../../AllHooks/CheckUserProvider';
import Popup from '../Popup';
import { useHistory } from 'react-router-dom';
import CustomAlert from '../CustomAlert';
import EditIcon from '@material-ui/icons/Edit';
import RefreshIcon from '@material-ui/icons/Refresh';
import { Helmet } from 'react-helmet';
import { getFranchiseEventsDocumentWithUserId } from '../../Backend/firebase/franchise-events';
import "./Dashboard.css"
import Skeleton from '../Skeleton';
const UpdateFranchiseEvents = React.lazy(() => import('./UpdateFranchiseEvents'));


const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'initial',
        flexDirection: 'column',
    },
    fixedHeight: {
        height: '100%',
    },
}));

const headCells = [
    { id: 'eventName', label: 'Event Name', disableSorting: false },
    { id: 'eventType', label: 'Type', disableSorting: true },
    { id: 'organizer', label: 'Organizer', disableSorting: true },
    { id: 'eventCategory', label: 'Category', disableSorting: true },
    { id: 'location', label: 'Location', disableSorting: false },
    { id: 'startDate', label: 'Start Date', disableSorting: false },
    { id: 'endDate', label: 'End Date', disableSorting: false },
    { id: 'lastDateOfRegistration', label: 'Last Date of Registration', disableSorting: false },
    { id: 'action', label: 'Action', disableSorting: false },
]

function FranchiseEvents() {
    const classes = useStyles();
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const { userData } = CheckUserProvider();
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [searchChange, setSearchChange] = useState(false);
    const [pageAfterSearch, setPageAfterSearch] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } = useTable(records, headCells, filterFn,
        searchChange, pageAfterSearch);
    const [openPopup, setOpenPopup] = useState(false);
    const [updatedEventId, setUpdatedEventId] = useState('');
    const history = useHistory();
    const [openNotify, setOpenNotify] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [isPageReload, setIsPageReload] = useState(false);

    const handleSearch = (e) => {
        let target = e.target;
        if (target.value === '') {
            setSearchChange(false);
            setPageAfterSearch(false);
        }
        else {
            setSearchChange(true);
            setPageAfterSearch(true);
        }
        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items
                } else {
                    return items.filter(x => x.eventName.toLowerCase().includes(target.value.toLowerCase()));
                }
            }
        });
    };

    useEffect(async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const getEvents = await getFranchiseEventsDocumentWithUserId(userData.uid);
                setRecords(getEvents);
                setIsLoading(false);
            } catch(error) {
                console.log("Error Occur in Get  Franchise", error)
                setIsLoading(false);
            }
        }
    }, [userData]);

    const updateEventPost = (productId) => {
        setUpdatedEventId(productId);
        setOpenPopup(true);
    };

    const handleFilters = async (filter) => {
        console.log('Filter Changed => ', filter);
    };

    const refreshData = async () => {
        if (userData) {
            setIsLoading(true);
            try {
                const getEvents = await getFranchiseEventsDocumentWithUserId(userData.uid);
                setRecords(getEvents);
                setIsLoading(false);
                setNotificationMessage('Events data has updated successfully.');
                setOpenNotify(true);
                setAlertType('success');
            } catch(error) {
                console.log("Error Occur in Get  Franchise", error)
                setIsLoading(false);
            }
        }
    };

    useEffect(async () => {
        if (isPageReload) {
            refreshData();
        }
    }, [isPageReload]);

    return (
        <>
            {!userData || isLoading ?
                (<div className="row">
                    <div className="col-md-12 text-center p-4">
                        <CircularProgress />
                    </div>
                </div>) :
                (<div className="allProducts">
                    <Paper className={fixedHeightPaper}>
                        <Helmet>
                            <meta name="description" content="Find Products you have posted till now." />
                            <title> Franchise | Kaipsool Franchisetech</title>
                        </Helmet>
                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="col-md-8">
                                <div className="allProducts__productStatusFilter">
                                    <div className="allProducts__productStatusContent">
                                        <Button variant="contained" className="employerIndex__createPostBtn"
                                            onClick={() => history.push('/retailer/create-franchise-events')}>Add New Franchise</Button>
                                    </div>
                                    <div className="allProducts__productStatusContent">
                                        <Tooltip title="Refresh with new data" placement="top">
                                            <IconButton color="secondary"
                                                onClick={refreshData}>
                                                <RefreshIcon fontSize='large' />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="d-flex justify-content-center align-items-center allProductsTable__searchBox">
                                    <SearchIcon className="mr-2" />
                                    <input type="text" placeholder="Search posted events" className="border-0"
                                        onChange={handleSearch} />
                                </div>
                            </div>
                            {records.length > 0 ? <div className="row col-md-12">
                                {/* <TblContainer> */}
                                    {/* <TblHead />
                                    <TableBody> */}
                                        {
                                            recordsAfterPagingAndSorting().map(item => (
                                                <>
                                                    <div className="col-lg-4 col-md-4 col-sm-12 topSkills topSkills__productDisplay" key={item.id}>
                                                        <div className="card-events card-products franchise-products">
                                                            <div className="card-events-body d-flex flex-column background__color position__class">
                                                                <div className="product__edit">
                                                                    <Tooltip title="Edit  Franchise" placement="top">
                                                                        <IconButton color="primary"
                                                                            onClick={() => updateEventPost(item?.uniqueId)}>
                                                                            <EditIcon />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </div>
                                                                <div className="card-events-details">
                                                                    <h5 className="card-events-title white__color product__mainTitle">{item?.eventName}</h5>
                                                                    <p className="card-events-title white__color">{item?.location}</p>
                                                                    <p className="card-events-title white__color">Type: <b>{item?.eventType}</b></p>
                                                                    <p className="card-events-title white__color">Certification:: <b>{item?.certification}</b></p>
                                                                    <p className="card-events-title white__color">Year of Establishment: <b>{item?.yearOfEstablishment}</b></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <TableRow key={item?.uniqueId}>
                                                        <TableCell>{item?.eventName}</TableCell>
                                                        <TableCell>{item?.eventType}</TableCell>
                                                        <TableCell>{item?.organizer}</TableCell>
                                                        <TableCell>{item?.eventCategory}</TableCell>
                                                        <TableCell>{item?.location}</TableCell>
                                                        <TableCell>{dateFormatter(item?.startDate?.toDate())}</TableCell>
                                                        <TableCell>{dateFormatter(item?.endDate?.toDate())}</TableCell>
                                                        <TableCell>{dateFormatter(item?.lastDateOfRegistration?.toDate())}</TableCell>
                                                        <TableCell>
                                                            <Tooltip title="Edit Product" placement="top">
                                                                <IconButton color="secondary"
                                                                    onClick={() => updateEventPost(item?.uniqueId)}>
                                                                    <EditIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow> */}
                                                </>
                                            ))
                                        }
                                    {/* </TableBody>
                                </TblContainer> */}
                                <TblPagination />
                            </div> : <div className="row col-md-12 mt-5 text-center">
                                <h4>No  Franchise Found!</h4>
                            </div>}
                        </div>
                    </Paper>
                </div>)
            }
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType || 'error'}
                notificationMessage={notificationMessage} />

            <Popup openPopup={openPopup} setOpenPopup={setOpenPopup} title="Update Franchise" popupSize="md">
                <Suspense fallback={<Skeleton />}>
                    <UpdateFranchiseEvents eventId={updatedEventId} setOpenPopup={setOpenPopup} setIsPageReload={setIsPageReload} />
                </Suspense>
            </Popup>
        </>
    )
}

export default FranchiseEvents
